module.exports = __webpack_public_path__ + "static/media/external_env_4_media_5.7105a53c.webp";